import { type FunctionalComponent, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

export interface IConversationalSearchProcessing {
  labelProvider: labelProviderInterface;
}

export const ConversationalSearchNewCovnersationFollowup: FunctionalComponent<
  IConversationalSearchProcessing
> = (props) => {
    const smilingFaceIcon = String.fromCodePoint(128578);

    return (
      <uiaas-search-conversational-search-messages-wrapper labelProvider={(e, f) => props.labelProvider(e, f)}>
        <span class="conversational-search-new-conversation-followup__header">
          {props.labelProvider(
            'conversational.search.new-conversation.follow.up.header',
            'How can I help you today?',
          )}
          {' ' + smilingFaceIcon}
        </span>
        <span class="conversational-search-new-conversation-followup__message">
          {props.labelProvider(
            'conversational.search.new-conversation.follow.up.message',
            'Describe the product you\'re looking for by typing your question in the field below.'
          )}
        </span>
      </uiaas-search-conversational-search-messages-wrapper>
    );
};
